// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  contentful: {
    spaceId: 'bj642nxfk7a3',
    token: '1ZJyRB19WfmqP-XIQ5KyAG_jHkez7hnEbv5IeaDDGYQ'
  },
  siteUrl:'https://uat.monarchtractor.com'
};



// WEBPACK FOOTER //
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/environments/environment.ts